import { chainKeyMap } from "./chain";
import { DEFAULT_CHAIN_KEY } from "./chain-legacy";
import { baseProtocolMap, ProtocolKey } from "./protocol";

export const PRECISE_DECIMALS = 36;

export const DEFAULT_PROTOCOL_KEY: ProtocolKey = "arbitrum";
export const DEFAULT_PROTOCOL_KEY_GUARD: typeof DEFAULT_CHAIN_KEY =
  chainKeyMap[baseProtocolMap[DEFAULT_PROTOCOL_KEY].chain.id];
